import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Card, CardBody, Button } from 'reactstrap';
import authenticatedFetcher from '../../services/fetcher';
import LoadingSpinner from '../LoadingSpinner';
import { Form } from 'react-bootstrap';
import { toastError, toastSuccess } from '../../utils/ToastConfig';

export default function CustomModalGenerateMicroCredentialsExcel(props) {
	const { toggle, open } = props;
	const [selectedEnterprise, setSelectedEnterprise] = useState('');
	const [enterprises, setEnterprises] = useState([]);
	const [loading, setLoading] = useState(true);
	const [loadingSubmit, setLoadingSubmit] = useState(false);

	const resetModal = () => {
		setSelectedEnterprise('');
		toggle();
	};

	const handleChange = ({ target: { value } }) => {
		setSelectedEnterprise(value);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!selectedEnterprise) return;
		setLoadingSubmit(true);
		await authenticatedFetcher({
			path: '/virtual-classrooms/courses/generate-micro-credentials-excel/',
			method: 'POST',
			body: { enterprise_pk: selectedEnterprise }
		}).then((res) => {
			setLoadingSubmit(false);
			if (res.__status || res.error) {
				if (res.error_data && Array.isArray(res.error_data.response))
					res.error_data.response.map((item) => toastError(item));
				else toastError(res.error);
			} else {
				toastSuccess(res.status || 'Generación iniciada', { autoClose: true });
				resetModal();
			}
		});
	};

	useEffect(() => {
		if (!open) return;
		setLoading(true);
		authenticatedFetcher({
			path: '/enterprises/',
			urlParams: { min: 1, nitems: 1000 }
		}).then((res) => {
			const items = res?.items || res || [];
			setEnterprises(Array.isArray(items) ? items : []);
			setLoading(false);
		});
	}, [open]);

	return (
		<Modal size="sm" toggle={toggle} isOpen={open}>
			<ModalHeader toggle={toggle} charCode="x">
				Generar Excel de MicroCredenciales
			</ModalHeader>
			<ModalBody>
				<Card>
					<CardBody>
						<div>
							{loading ? (
								<div className="d-flex justify-content-center">
									<LoadingSpinner show={loading} />
								</div>
							) : (
								<form onSubmit={handleSubmit}>
									<div className="row">
										<div className="col-md-12">
											<Form.Group>
												<Form.Label>Seleccione la empresa:</Form.Label>
												<Form.Control
													as="select"
													name="enterprise_pk"
													value={selectedEnterprise}
													onChange={handleChange}>
													<option value="">-- Seleccione --</option>
													{enterprises.map((item) => (
														<option key={item.pk} value={item.pk}>
															{item.name}
														</option>
													))}
												</Form.Control>
											</Form.Group>
											<div className="w-100 mb-3 d-flex justify-content-end">
												<Button
													type="button"
													className="submitButton mr-2"
													onClick={resetModal}>
													Cancelar
												</Button>
												<Button
													type="submit"
													className="submitButton"
													disabled={loadingSubmit || !selectedEnterprise}>
													Generar
													<LoadingSpinner show={loadingSubmit} />
												</Button>
											</div>
										</div>
									</div>
								</form>
							)}
						</div>
					</CardBody>
				</Card>
			</ModalBody>
		</Modal>
	);
}

CustomModalGenerateMicroCredentialsExcel.defaultProps = {
	toggle: () => {},
};
